import { render, staticRenderFns } from "./ord_sent_two.vue?vue&type=template&id=2fcd52f8&scoped=true&"
import script from "./ord_sent_two.vue?vue&type=script&lang=js&"
export * from "./ord_sent_two.vue?vue&type=script&lang=js&"
import style0 from "./ord_sent_two.vue?vue&type=style&index=0&id=2fcd52f8&scoped=true&lang=less&"
import style1 from "./ord_sent_two.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcd52f8",
  null
  
)

export default component.exports